// extracted by mini-css-extract-plugin
module.exports =  {"controls":"_7a3fb80146--controls--mJy8A","fixed":"_7a3fb80146--fixed--OF7ak"};